var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "ma-3", attrs: { align: "center", justify: "center" } },
        [
          _c(
            "v-card",
            { attrs: { align: "left", justify: "left" } },
            [
              _c(
                "v-card-text",
                { staticClass: "pa-3 font-weight-light white black--text" },
                [
                  _c("v-icon", { staticClass: "primary--text pa-2" }, [
                    _vm._v(" fa-sharp fa-solid fa-percent ")
                  ]),
                  _vm._v("Renegociação > Gerenciar Ofertas Globais ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            {
              staticClass: "my-3 pa-3",
              staticStyle: { "border-radius": "20px" },
              attrs: { color: "primary" }
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-3 pa-3",
                      attrs: { cols: "3", xs: "3", md: "3" }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "white--text ma-6 pa-6 mx-auto my-auto",
                          attrs: { size: "100", "elevation-8": "" }
                        },
                        [_vm._v(" fa-sharp fa-solid fa-percent ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-3 pa-3 mx-auto my-auto",
                      attrs: {
                        cols: "12",
                        sm: "12",
                        md: "5",
                        align: "left",
                        justify: "left"
                      }
                    },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "white--text display-1" },
                        [
                          _vm._v(" Gerenciar Ofertas "),
                          _c("strong", [_vm._v("Globais")]),
                          _c(
                            "v-chip",
                            {
                              staticClass: "ma-2",
                              attrs: {
                                color: "secondary",
                                label: "",
                                "text-color": "white"
                              }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v(" mdi-label ")
                              ]),
                              _vm._v(" Novidade! ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-3 pa-3 mx-auto my-auto",
                      attrs: {
                        sm: "12",
                        md: "2",
                        align: "left",
                        justify: "left"
                      }
                    },
                    [
                      _c(
                        "v-card-text",
                        {
                          staticClass:
                            "white--text font-weight-light subtitle mb-3 pa-3"
                        },
                        [
                          _vm._v(
                            " Crie e gerencie ofertas, podendo criar com base em datas, porcentagem de desconto e valores. "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card",
                {
                  staticClass: "ma-6",
                  attrs: { "elevation-0": "", outlined: "" }
                },
                [
                  _c(
                    "v-expansion-panels",
                    [
                      _c(
                        "v-expansion-panel",
                        [
                          _c(
                            "v-expansion-panel-header",
                            { staticClass: "grey lighten-4" },
                            [
                              _c(
                                "v-card-text",
                                {
                                  staticClass: "font-weight-light black--text"
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { staticClass: "primary--text lighten-2" },
                                    [_vm._v(" search ")]
                                  ),
                                  _vm._v(" Filtrar Resultados ")
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c(
                                "v-row",
                                { staticClass: "my-4" },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mx-2",
                                      attrs: {
                                        cols: "9",
                                        sm: "12",
                                        md: "12",
                                        lg: "3"
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          solo: "",
                                          label: "Id da Oferta",
                                          hint: "Informe o id único da oferta",
                                          placeholder: "0001"
                                        },
                                        model: {
                                          value: _vm.filtros.id,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filtros, "id", $$v)
                                          },
                                          expression: "filtros.id"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { right: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticClass: "my-auto",
                                                      attrs: {
                                                        color:
                                                          "grey lighten-2\n"
                                                      }
                                                    },
                                                    "v-icon",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [_vm._v(" help ")]
                                              )
                                            ]
                                          }
                                        }
                                      ])
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          'Cada oferta possui um número único chamado de "id". Informe o id da oferta que deseja encontrar.'
                                        )
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "mx-2",
                                      attrs: {
                                        cols: "9",
                                        xs: "12",
                                        sm: "12",
                                        lg: "2"
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          solo: "",
                                          label: "Valor Inicial",
                                          hint: "Informe o valor inicial",
                                          placeholder: "R$ 0,00"
                                        },
                                        model: {
                                          value: _vm.filtros.valor_inicial,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filtros,
                                              "valor_inicial",
                                              $$v
                                            )
                                          },
                                          expression: "filtros.valor_inicial"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { right: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        color: "grey lighten-2"
                                                      }
                                                    },
                                                    "v-icon",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [_vm._v(" help ")]
                                              )
                                            ]
                                          }
                                        }
                                      ])
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Informe o valor inicial da Oferta"
                                        )
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "mx-2 d-flex justify-center align-center",
                                      attrs: {
                                        cols: "6",
                                        xs: "2",
                                        sm: "2",
                                        md: "2",
                                        lg: "2"
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          solo: "",
                                          label: "Valor Final",
                                          hint: "Informe o valor final",
                                          placeholder: "R$ 0,00"
                                        },
                                        model: {
                                          value: _vm.filtros.valor_final,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filtros,
                                              "valor_final",
                                              $$v
                                            )
                                          },
                                          expression: "filtros.valor_final"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { right: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        color: "grey lighten-2"
                                                      }
                                                    },
                                                    "v-icon",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [_vm._v(" help ")]
                                              )
                                            ]
                                          }
                                        }
                                      ])
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Informe o valor final da Oferta"
                                        )
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "mx-2 d-flex justify-center align-center",
                                      attrs: {
                                        cols: "6",
                                        xs: "2",
                                        sm: "2",
                                        md: "3",
                                        lg: "3"
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass:
                                          "mt-n1 d-flex justify-center",
                                        attrs: {
                                          label: "Somente Ofetas ativas",
                                          "item-text": "nm_status",
                                          "item-value": "status",
                                          "return-object": true
                                        },
                                        model: {
                                          value: _vm.filtros.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filtros, "status", $$v)
                                          },
                                          expression: "filtros.status"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            {
              staticClass: "pa-3",
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.aplicarFiltros.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "v-row",
                { staticClass: "my-1" },
                [
                  _c("v-col", {
                    staticClass: "mx-3",
                    attrs: { cols: "4", xs: "2", sm: "2", md: "7", lg: "7" }
                  }),
                  _c(
                    "v-col",
                    {
                      staticClass: "mx-2",
                      attrs: {
                        cols: "11",
                        xs: "6",
                        sm: "6",
                        md: "2",
                        lg: "2",
                        align: "center"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mt-n1 d-flex justify-center",
                          attrs: {
                            width: "180",
                            color: "primary",
                            loading: _vm.loadingFiltros
                          },
                          on: { click: _vm.botaoFiltrar }
                        },
                        [
                          _vm._v(" Buscar "),
                          _c("v-icon", { staticClass: "ml-2" }, [
                            _vm._v("search")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mx-2",
                      attrs: {
                        cols: "11",
                        xs: "6",
                        sm: "6",
                        md: "2",
                        lg: "2",
                        align: "center"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mt-n1 d-flex justify-center",
                          attrs: {
                            width: "180",
                            color: "green white--text",
                            loading: _vm.loadingFiltros
                          },
                          on: { click: _vm.criarOferta }
                        },
                        [
                          _vm._v(" Nova Oferta "),
                          _c("v-icon", { staticClass: "ml-2" }, [_vm._v("add")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.snackbar
            ? _c("Snackbar", {
                attrs: {
                  mostrarSnackbar: _vm.snackbar,
                  corSnackbar: _vm.snackbarColor,
                  mensagemSnackbar: _vm.mensagemAviso
                },
                on: {
                  fecharSnackbar: function($event) {
                    _vm.snackbar = false
                  }
                }
              })
            : _vm._e(),
          _c("v-data-table", {
            staticClass: "elevation-1 pa-3 mt-3",
            attrs: {
              headers: _vm.headers,
              items: _vm.ofertas,
              "item-key": "ofertas"
            },
            scopedSlots: _vm._u(
              [
                {
                  key: `item.id`,
                  fn: function({ item }) {
                    return [_c("span", [_vm._v(" " + _vm._s(item.id) + " ")])]
                  }
                },
                {
                  key: `item.valor_de`,
                  fn: function({ item }) {
                    return [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatDinheiroString(item.valor_de)) +
                            " "
                        )
                      ])
                    ]
                  }
                },
                {
                  key: `item.valor_ate`,
                  fn: function({ item }) {
                    return [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatDinheiroString(item.valor_ate)) +
                            " "
                        )
                      ])
                    ]
                  }
                },
                {
                  key: `item.data_inicio`,
                  fn: function({ item }) {
                    return [
                      _c("span", [
                        _vm._v(
                          " " + _vm._s(_vm.formatDate(item.data_inicio)) + " "
                        )
                      ])
                    ]
                  }
                },
                {
                  key: `item.data_fim`,
                  fn: function({ item }) {
                    return [
                      _c("span", [
                        _vm._v(
                          " " + _vm._s(_vm.formatDate(item.data_fim)) + " "
                        )
                      ])
                    ]
                  }
                },
                {
                  key: `item.desconto_porcentagem`,
                  fn: function({ item }) {
                    return [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formatPorcentagem(item.desconto_porcentagem)
                            ) +
                            " "
                        )
                      ])
                    ]
                  }
                },
                {
                  key: `item.desconto`,
                  fn: function({ item }) {
                    return [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatDinheiroString(item.desconto)) +
                            " "
                        )
                      ])
                    ]
                  }
                },
                {
                  key: `item.status`,
                  fn: function({ item }) {
                    return [
                      _c("v-switch", {
                        style: {
                          color: item.status != "" ? "green" : "red"
                        },
                        attrs: {
                          color: item.status != "" ? "green" : "red",
                          readonly: "",
                          inset: ""
                        },
                        model: {
                          value: item.status,
                          callback: function($$v) {
                            _vm.$set(item, "status", $$v)
                          },
                          expression: "item.status"
                        }
                      })
                    ]
                  }
                },
                {
                  key: `item.cartao`,
                  fn: function({ item }) {
                    return [
                      _c(
                        "v-icon",
                        {
                          style: { color: item.cartao != "" ? "green" : "red" }
                        },
                        [_vm._v(_vm._s(_vm.getBolean(item.cartao)))]
                      )
                    ]
                  }
                },
                {
                  key: `item.juros_cartao`,
                  fn: function({ item }) {
                    return [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatPorcentagem(item.juros_cartao)) +
                            " "
                        )
                      ])
                    ]
                  }
                },
                {
                  key: `item.boleto`,
                  fn: function({ item }) {
                    return [
                      _c(
                        "v-icon",
                        {
                          style: { color: item.boleto != "" ? "green" : "red" }
                        },
                        [_vm._v(_vm._s(_vm.getBolean(item.boleto)))]
                      )
                    ]
                  }
                },
                {
                  key: `item.juros_boleto`,
                  fn: function({ item }) {
                    return [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatPorcentagem(item.juros_boleto)) +
                            " "
                        )
                      ])
                    ]
                  }
                },
                {
                  key: `item.action`,
                  fn: function({ item }) {
                    return [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2 grey white--text",
                          attrs: {
                            small: "",
                            elevation: "1",
                            width: "100%",
                            loading: _vm.loadingFiltros
                          },
                          on: {
                            click: function($event) {
                              return _vm.exibirDetalhe(item)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2",
                              style: { color: "white" },
                              attrs: { small: "" },
                              on: {
                                click: function($event) {
                                  return _vm.exibirDetalhe(item)
                                }
                              }
                            },
                            [_vm._v("edit")]
                          ),
                          _vm._v(" Editar ")
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _vm.dialog
        ? _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "1200px",
                persistent: "",
                color: "background",
                transition: "dialog-bottom-transition"
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c("validation-observer", {
                ref: "observer",
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ invalid }) {
                        return [
                          _c(
                            "form",
                            {
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.submit.apply(null, arguments)
                                }
                              }
                            },
                            [
                              _c(
                                "form",
                                { ref: "ofertaForm" },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "ml-1" },
                                    [
                                      _c(
                                        "v-toolbar",
                                        {
                                          attrs: {
                                            flat: "",
                                            dark: "",
                                            color: "primary"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "", dark: "" },
                                              on: { click: _vm.closeDialog }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("mdi-close")
                                              ])
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "2",
                                                align: "left"
                                              }
                                            },
                                            [
                                              _c("v-toolbar-title", [
                                                _vm._v("Criar Oferta")
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-card-text",
                                        [
                                          _c("DetalheOferta", {
                                            attrs: {
                                              oferta: _vm.oferta,
                                              activeIdOffer: _vm.activeIdOffer
                                            },
                                            on: {
                                              fecharModal: _vm.closeDialog,
                                              fecharModalSuccess:
                                                _vm.closeDialogSuccess,
                                              fecharModalError:
                                                _vm.closeDialogError
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-container",
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "pa-2",
                                              attrs: {
                                                align: "baseline",
                                                justify: "end"
                                              }
                                            },
                                            [
                                              _vm.oferta.id
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ml-5",
                                                      attrs: {
                                                        dense: "",
                                                        color:
                                                          "grey white--text"
                                                      },
                                                      on: {
                                                        click: _vm.closeDialog
                                                      }
                                                    },
                                                    [_vm._v(" Fechar ")]
                                                  )
                                                : _vm._e(),
                                              !_vm.oferta.id
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ml-5",
                                                      attrs: {
                                                        dense: "",
                                                        color: "error"
                                                      },
                                                      on: {
                                                        click: _vm.closeDialog
                                                      }
                                                    },
                                                    [_vm._v(" Cancelar ")]
                                                  )
                                                : _vm._e(),
                                              !_vm.oferta.id
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ml-5",
                                                      attrs: {
                                                        color:
                                                          "green white--text",
                                                        disabled: invalid
                                                      },
                                                      on: {
                                                        click: _vm.salvarOferta
                                                      }
                                                    },
                                                    [_vm._v(" Salvar ")]
                                                  )
                                                : _vm._e(),
                                              _c("v-icon", {
                                                staticClass: "ml-2"
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3408172115
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }